import { API_BASE_URL } from "@/services/API/urls.api";

/**
 * Configuración del mapa de localización
 */
export const MAP_CONFIG = {
  ZOOM_LEVEL: 18,
  MAX_ZOOM: 19,
  COORDINATE_PRECISION: 6,
  UPDATE_THRESHOLD: 0.00001,
  LEAFLET: {
    CSS_URL: "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css",
    CSS_INTEGRITY: "sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=",
    JS_URL: "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js",
    JS_INTEGRITY: "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=",
  },
  TILES: {
    // Proxied through the backend so the CARTO API key never reaches the frontend.
    URL: `${API_BASE_URL}/map-tiles/{z}/{x}/{y}`,
    ATTRIBUTION:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
  },
} as const;

declare global {
  interface Window {
    L: any;
  }
}
